import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Table } from 'antd';
import styles from './FuelTransactionItems.styles';
import { renderText } from '../shared/DrawerLayout/renderText';
import { selectSelectedFuelTransaction } from '../../redux/store/userData/fuelTransactions';
import { formatFuelAmount, formatLitrePrice, formatLitres } from '../../utils';

const FuelTransactionItems: React.FC = () => {
  const intl = useIntl();
  const fuelTransaction = useSelector(selectSelectedFuelTransaction);

  const title = (key: string, defaultMessage: string) =>
    intl.formatMessage({
      id: `fleetadmin.fuelTransactions.items.${key}`,
      defaultMessage,
    });

  const columns: any[] = [
    {
      title: title('product', 'Product'),
      dataIndex: 'product',
      render: renderText,
    },
    {
      title: title('quantity', 'Quantity'),
      dataIndex: 'quantity',
      render: formatLitres,
    },
    {
      title: title('€/L', '€/L'),
      dataIndex: 'pricePerLitre',
      render: formatLitrePrice,
    },
    {
      title: title('netamount', 'Net'),
      dataIndex: 'netAmount',
      render: formatFuelAmount,
    },
    {
      title: title('vatamount', 'VAT'),
      dataIndex: 'vatAmount',
      render: formatFuelAmount,
    },
    {
      title: title('amounttotal', 'Gross'),
      dataIndex: 'amountTotal',
      render: formatFuelAmount,
    },
  ];

  /* The API returns one product per transaction, so the table has a single row. */
  const dataSource = fuelTransaction ? [{ ...fuelTransaction, key: 0 }] : [];

  return (
    <>
      <div className="fuel-transaction-items">
        <Table
          size="small"
          pagination={false}
          columns={columns}
          dataSource={dataSource}
        />
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FuelTransactionItems;
